// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "id.competence",
    name: "Competence.id",
    homepage: "https://competence.id",
    image_id: "ac1de66e-a82c-4cc5-f460-86b640e56500",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/competenceid/id6448860364",
        android: "https://play.google.com/store/apps/details?id=id.competence",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "competenceid://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map